import React, { useEffect, useState } from "react";
import InboxIcon from "@atlaskit/icon/core/inbox";
import Button from "@atlaskit/button/new";
import Select from "@atlaskit/select";
import { Label } from "@atlaskit/form";

import { useDispatch, useSelector } from "react-redux";
import { Popover } from "antd";
import { hasMoreThanKey } from "../../../../../common/utils/objects.util";
import { getLogItem } from "../../../../../redux/actions/logActions";
import { flattenJSON } from "../../../../../common/utils/flattern";

const ShowFullScopeVariablePathExtension = ({ flowId, action }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [options, setOptions] = useState([]);
  const [value, setValue] = useState(null);
  const dispatch = useDispatch();

  const logs = useSelector((state) => state.integration.logs);

  const getLogDetails = () => {
    if (logs && logs.result) {
      const actionLog =
        logs.result.find((log) => log.actionId === action?.id) || null;
      //Load from S3
      if (actionLog?.scope?.key && !hasMoreThanKey(actionLog?.scope)) {
        dispatch(getLogItem(flowId, actionLog?.scope?.key));
      } else if (actionLog?.scope) {
        const rest = flattenJSON(actionLog?.scope);
        setOptions(rest);
      } else {
        setOptions([]);
        setValue(null);
      }
    } else {
      setOptions([]);
      setValue(null);
    }
  };

  useEffect(() => {
    getLogDetails();
  }, [logs, action]);

  const renderContent = () => {
    return (
      <>
        <div className="atlassian-theme">
          <b>Available Data Fields (from Last Execution)</b>
        </div>
        <Label>Data field</Label>
        <Select
          spacing={"compact"}
          inputId="flows"
          className="hub-flows"
          options={options}
          placeholder="Select a data field"
          onChange={setValue}
        />
        {value && (
          <div style={{ marginTop: "10px" }}>
            <p>Selected Data Field: {value.label}</p>
            <ul>
              <li>
                <strong>JSON Path:</strong> <code>$.{value.value}</code>
              </li>
              <li>
                <strong>Mustache:</strong>{" "}
                <code>&#123;&#123;{value.value}&#125;&#125;</code>
              </li>
              <li>
                <strong>Javascript (scripted variables):</strong>{" "}
                <code>jsonContext.{value.value}</code>
              </li>
            </ul>
          </div>
        )}
        {options.length === 0 && (
          <p>
            <span className="atlassian-theme">
              No data fields available for this action. Hint: Run the flow to
              load data from the request.{" "}
            </span>
          </p>
        )}
      </>
    );
  };
  const togglePopUp = () => {
    setIsVisible(!isVisible);
    getLogDetails();
  };

  return (
    <div className="ihub-actionmenu-icons">
      <>
        <Popover
          content={renderContent()}
          title=""
          trigger="click"
          open={isVisible}
          onOpenChange={setIsVisible}
        >
          <Button
            iconBefore={InboxIcon}
            appearance="subtle"
            onClick={togglePopUp}
          />
        </Popover>
      </>
    </div>
  );
};
export default ShowFullScopeVariablePathExtension;
